import React, { HTMLProps } from 'react';
import styled from 'styled-components';
import { ComboboxInput, ComboboxInputProps } from '@reach/combobox';

import useTranslation from 'src/hooks/use-translation';
import { useAddressAutocomplete } from '../context';

type AddressAutocompleteInputProps = {
  withClearButton?: boolean;
  withPinAdornment?: boolean;
};

export function AddressAutocompleteInput({
  onChange,
  ...props
}: AddressAutocompleteInputProps & ComboboxInputProps & HTMLProps<HTMLInputElement>): JSX.Element {
  const { t } = useTranslation();
  const { displayValue, handleInputChange, inputRef } = useAddressAutocomplete();

  function handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
    onChange?.(e);
    handleInputChange(e);
  }

  return (
    <StyledComboboxInput
      ref={inputRef}
      value={displayValue}
      onChange={handleChange}
      aria-label={t('common.enterYourAddress', 'Enter your address')}
      autoComplete='off'
      {...props}
    />
  );
}

const StyledComboboxInput = styled(ComboboxInput)`
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.grey[25]};
  ::placeholder {
    color: ${({ theme }) => theme.colors.grey[35]};
  }
`;
